import React from "react";
import Container from "react-bootstrap/Container";
import Team from "../images/team.png";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Profile2 from "../images/picture.png";
import Profile3 from "../images/image 56.png";
import Profile7 from "../images/MD-profile.png";
import Profile11 from "../images/image83.png";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Link } from "react-router-dom";
import NavLink2 from "../compnents/NavLink2";
import Footer5 from "../compnents/Footer5";
import Footer4 from "../compnents/Footer4";
import Image44 from "../images/Rectangle 44.png";
// Functions for modal

function MyVerticallyCenteredModal6(props) {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body style={{ display: "flex", padding: "30px" }}>
        <div className="profile-box">
          <img
            src={Profile2}
            alt=""
            className="profile-img"
            style={{ marginBottom: "20px" }}
          />
          <h4>Peace Samuel</h4>
          <p>Compliance Officer</p>
        </div>
        <p style={{ marginLeft: "30px" }}>
          Peace Oderah Ekene-Okeke is the Chief Compliance Officer of TrustBanc Asset Management, 
          with over ten years of experience in regulatory compliance, risk management, and corporate 
          governance within the financial services and capital markets sectors. She is responsible 
          for overseeing the firm’s compliance framework, ensuring adherence to regulatory requirements, 
          and promoting a strong culture of ethics and accountability across the organization.
 
          Prior to joining TrustBanc Asset Management, Peace worked with Access Bank Plc as a Regulatory 
          Liaison Officer and Compliance Officer for subsidiary operations, where she managed regulatory 
          engagements, compliance monitoring, and regulatory reporting. She brings deep expertise in 
          compliance risk management, AML/CFT, regulatory advisory, and stakeholder engagement.
 
          Peace is committed to upholding the highest standards of regulatory compliance and supporting the firm’s 
          long-term growth and institutional integrity.
        </p>
      </Modal.Body>
    </Modal>
  );
}
function MyVerticallyCenteredModal7(props) {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body style={{ display: "flex", padding: "30px" }}>
        <div className="profile-box">
          <img
            src={Profile3}
            alt=""
            className="profile-img"
            style={{ marginBottom: "20px" }}
          />
          <h4>Adisa Moshood Abiola</h4>
          <p>Head of Treasury & Portfolio Management</p>
        </div>
        <p style={{ marginLeft: "30px" }}>
          Adisa has close to a decade experience in the financial services industry across 
          financial control, investment portfolio and liquidity management. He started his 
          career in the financial services industry in 2013 as an accountant with Cowry Asset 
          Management Limited, before joining Capitalfield Asset Management Limited in January 
          2018 as the Chief Financial Officer where he was charged with setting up the accounting 
          department. He qualified as a chartered accountant while in 300 level at Olabisi 
          Onabanjo University where he graduated from the department of Accounting with a 
          second-class upper division. Adisa has vast experience in investment portfolio and 
          liquidity management.
        </p>
      </Modal.Body>
    </Modal>
  );
}
function MyVerticallyCenteredModal8(props) {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body style={{ display: "flex", padding: "30px" }}>
        <div className="profile-box">
          <img
            src={Profile7}
            alt=""
            className="profile-img"
            style={{ marginBottom: "20px" }}
          />
          <h4>Rukayat Mutiu</h4>
          <p>Compliance Officer</p>
        </div>
        <p style={{ marginLeft: "30px" }}>

          Rukayat has over 9 years of experience in capital Market which spans across Portfolio Management, Operations, Finance and Compliance. She started her career with Associated Discount House now Coronation Merchant Bank where she served in various capacity in the Bank and Capital Market Subsidiaries within the Group.
          She joined Gresham Asset Management in 2019, where she oversees the Compliance, Operations and Finance functions of the business. She played a vital role in automation of the business operational processes, collaboration with relevant stakeholders on process and application improvement.
          She is a graduate of Accounting from University of Ilorin and Associate member of the Institute of Chartered Accountant of Nigeria. Rukayat Joined TrustBanc as Operations and Compliance specialist in 2022.

        </p>
      </Modal.Body>
    </Modal>
  );
}


function TeamPage() {
  const [modalShow6, setModalShow6] = React.useState(false);
  const [modalShow7, setModalShow7] = React.useState(false);
  const [modalShow8, setModalShow8] = React.useState(false);

  return (
    <div className="team-page">
      <div
        className="main-MF"
        style={{
          backgroundImage: `url(${Team})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          height: "150px",
          textAlign: "center",
          boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.1)"
        }}
      >
        <div>
          <NavLink2 />
          <h1>Our Team</h1>
        </div>
      </div>
      {/* <div className="team-page-card1">
        <button className="team-page-btn1">
          <Link to="/ourteam" className="team-links">
            Management Team
          </Link>
        </button>
        <button className="team-page-btn2">
          <Link to="/advisorycommitee" className="team-links2">
            Advisory Committee of Experts
          </Link>
        </button>
      </div> */}
      <div className="team-page-card2">
        <h2
          style={{
            textAlign: "",
            color: "#044188",
            lineHeight: "59px"
          }}
        >
          Management Team
        </h2>
        <Container style={{ width: "60%" }} className="mx-auto p-2">
          <Row className="mt-2 mx-auto p-2">
            <Col className="p-0 m-0">
              <div className="profile-box">
                <img src={Profile7} alt="" className="profile-img" />
                <Button variant="link" onClick={() => setModalShow8(true)}>
                  {" "}
                  <h4>Rukayat Mutiu</h4>
                </Button>{" "}
                <MyVerticallyCenteredModal8
                  show={modalShow8}
                  onHide={() => setModalShow8(false)}
                />
                <p>Managing Director</p>
              </div>
            </Col>
            <Col className="p-0 m-0">
              <div className="profile-box">
                <img src={Profile2} alt="" className="profile-img" />
                <Button variant="link" onClick={() => setModalShow6(true)}>
                  <h4>Peace Samuel</h4>
                </Button>
                <MyVerticallyCenteredModal6
                  show={modalShow6}
                  onHide={() => setModalShow6(false)}
                />
                <p>Compliance Officer</p>
              </div>
            </Col>
            <Col className="p-0 m-0">
              <div className="profile-box">
                <img src={Profile3} alt="" className="profile-img" />
                <Button variant="link" onClick={() => setModalShow7(true)}>
                  <h4>Adisa Moshood Abiola</h4>
                </Button>
                <MyVerticallyCenteredModal7
                  show={modalShow7}
                  onHide={() => setModalShow7(false)}
                />
                <p>Head of Treasury & Portfolio Management</p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <div>
        <Footer5 />
      </div>
      <div className="footer-4">
        <Footer4 />
      </div>
    </div>
  );
}

export default TeamPage;
